// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:36:54

export default {
  "id": "dye-it-right-color-picker",
  "slug": "dye-it-right-color-picker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b46a6d12764b4894835e808633fea77d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b46a6d12764b4894835e808633fea77d/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dye It Right: Color Picker",
      "description": "Welcome to the wonderful world of Dye It Right: Color Picker, where creativity meets fun! In this casual puzzle game, you’ll begin a colorful journey. This game is filled with exciting challenges designed for kids and the young at heart.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle",
        "Casual"
      ],
      "tags": [
        "challenge",
        "journey",
        "kidgames"
      ]
    },
    "zh-CN": {
      "title": "染对颜色：颜色选择器",
      "description": "欢迎来到Dye It Right: Color Picker的奇妙世界，在这里创意与乐趣相会！在这款休闲解谜游戏中，你将开始一段多彩的旅程。这款游戏充满了专为孩子们和心灵年轻的人设计的激动人心的挑战。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "拼图",
        "休闲"
      ],
      "tags": [
        "挑战",
        "旅程",
        "儿童游戏"
      ]
    },
    "zh-TW": {
      "title": "染對：顏色選擇器",
      "description": "歡迎來到絕妙的《染對了：顏色選擇器》世界，這裡創意與樂趣相結合！在這款休閒益智遊戲中，你將踏上色彩之旅。遊戲內充滿了為孩童和年輕心靈設計的挑戰。",
      "instructions": "滑鼠點擊或滑動按鍵開始遊戲",
      "genres": [
        "謎題",
        "休閒遊戲"
      ],
      "tags": [
        "挑戰",
        "旅程",
        "兒童遊戲"
      ]
    },
    "zh-HK": {
      "title": "染對：顏色選擇器",
      "description": "歡迎來到充滿奇妙的「染對了：顏色選擇器」世界，創意與樂趣在此相遇！在這款輕鬆解謎遊戲中，你將踏上色彩之旅。遊戲內充滿為小朋友及年輕心靈設計的挑戰。",
      "instructions": "用滑鼠點擊或觸碰以遊玩",
      "genres": [
        "謎題",
        "休閒"
      ],
      "tags": [
        "挑戰",
        "旅程",
        "兒童遊戲"
      ]
    },
    "ja": {
      "title": "色を正しく染めろ：色選択ツール",
      "description": "ウェルカム、素晴らしい世界「Dye It Right: Color Picker」へ！創造性と楽しみが交じったパズルゲームにようこそ。このカジュアルパズルゲームで、色とりどりの冒険の始まりを迎えます。このゲームは、子どもや心に子供のようになれる人々向けの魅力的な挑戦が満載です。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "パズル",
        "カジュアル"
      ],
      "tags": [
        "挑戦",
        "旅",
        "子供向けゲーム"
      ]
    },
    "ko": {
      "title": "빛내다 정확하게: 색상 선택기",
      "description": "Dye It Right: Color Picker의 아름다운 세상에 오신 것을 환영합니다! 창의성과 즐거움이 만나는 이 캐주얼 페즈 게임에서 다양한 색상의 여정을 시작하십시오. 이 게임은 아이들과 마음을 새롭게 하는 사람들을 위한 흥미진진한 도전 과제로 가득합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "퍼즐",
        "캐주얼"
      ],
      "tags": [
        "挑戦",
        "여정",
        "아이게임"
      ]
    },
    "fr": {
      "title": "Teintez Correctement : Sélecteur de Couleur",
      "description": "Bienvenue dans le merveilleux monde de Dye It Right: Color Picker, où la créativité rencontre le plaisir ! Dans ce jeu de puzzle casual, vous entamerez un voyage coloré. Ce jeu est rempli de défis captivants conçus pour les enfants et les âmes jeunes de cœur.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle",
        "Loisir"
      ],
      "tags": [
        "défis",
        "voyage",
        "jeux pour enfants"
      ]
    }
  }
};
